import { useQuery } from "react-query";
import SearchService from "../api/services/SearchService";

export const useCategories = () => {
  return useQuery(["categories"], () => SearchService.getCategories(), {
    keepPreviousData: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    select({ data }) {
      return data?.groups.map(({ id, name }: any) => ({
        value: id,
        label: name,
      }));
    },
  });
};
